import type { TOC } from '@ember/component/template-only';

interface HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooterSignature {
  Args: {};
  Blocks: {
    default: [];
  };
}

const HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter =
  <template>
    <div class="smart-compset__builder__footer">
      {{yield}}
    </div>
  </template> satisfies TOC<HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooterSignature>;

export default HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter;
